import { normalizeBakedText } from "./bakedIllustration.js";
const TITLE_ROLES = new Set(["title", "subtitle", "kicker", "caption"]);
/** U9 — text widget render mode (default vector). */
export function getTextRenderMode(layer) {
    if (layer.type !== "text")
        return "vector";
    const raw = layer.style?.renderMode;
    return raw === "raster" ? "raster" : "vector";
}
export function setTextRenderMode(layer, mode) {
    if (layer.type !== "text")
        return layer;
    return {
        ...layer,
        style: {
            ...layer.style,
            renderMode: mode === "vector" ? undefined : mode,
        },
    };
}
export function getTextRasterAssetKey(layer) {
    const raw = layer.style?.rasterAssetKey;
    return typeof raw === "string" && raw.trim() ? raw.trim() : undefined;
}
export function isTextRasterLayer(layer) {
    return layer.type === "text" && getTextRenderMode(layer) === "raster";
}
export function isTextRasterStale(layer) {
    return layer.style?.rasterStale === true;
}
export function markRasterStale(layer, stale) {
    if (layer.type !== "text")
        return layer;
    return {
        ...layer,
        style: {
            ...layer.style,
            rasterStale: stale ? true : undefined,
        },
    };
}
/** Map text layer content + role → baked illustration payload. */
export function bakedTextFromTextLayer(layer) {
    const text = layer.content?.trim() ?? "";
    const role = layer.textRole ?? "body";
    if (!text)
        return {};
    if (role === "bullet" || role === "body") {
        const bullets = text
            .split("\n")
            .map((line) => line.replace(/^•\s*/, "").trim())
            .filter(Boolean);
        return normalizeBakedText({ bullets: bullets.length ? bullets : [text] });
    }
    if (TITLE_ROLES.has(role)) {
        return normalizeBakedText({ title: text });
    }
    return normalizeBakedText({ title: text });
}
export function textRasterAltText(layer) {
    const text = layer.content?.trim();
    return text?.slice(0, 500) || "Illustrazione con testo";
}
/** Widget aspect on 16:9 slide → nearest discrete image aspect. */
export function aspectFromRect(w, h) {
    if (w <= 0 || h <= 0)
        return "3:2";
    const ratio = (w / h) * (16 / 9);
    const targets = [
        { aspect: "2:3", value: 2 / 3 },
        { aspect: "1:1", value: 1 },
        { aspect: "3:2", value: 3 / 2 },
    ];
    let best = targets[1];
    let bestDist = Math.abs(ratio - best.value);
    for (const t of targets) {
        const d = Math.abs(ratio - t.value);
        if (d < bestDist) {
            best = t;
            bestDist = d;
        }
    }
    return best.aspect;
}
export function imageSizeForAspect(aspect) {
    switch (aspect) {
        case "1:1":
            return "1024x1024";
        case "2:3":
            return "1024x1536";
        case "3:2":
        default:
            return "1536x1024";
    }
}
export function applyTextRasterGeneration(layer, outputAssetKey, aspect, rasterBackdrop) {
    // Transparent (cutout) generations carry no backdrop → render draws no solid panel.
    const backdrop = rasterBackdrop && rasterBackdrop.trim() ? rasterBackdrop : undefined;
    return {
        ...layer,
        style: {
            ...layer.style,
            renderMode: "raster",
            rasterAssetKey: outputAssetKey,
            rasterAspect: aspect,
            rasterStale: false,
            rasterBackdrop: backdrop,
            // New raster bitmap ⇒ any previous graphic crop no longer maps.
            crop: undefined,
        },
    };
}
